import { useLocation } from 'react-router-dom'
import { useQuestionsDetail } from '../../api/hooks/Questions/useQuestionsDetail'
import QuizContent from '../../components/admin/QuizContent'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'

const QuizEdit = () => {
  const location = useLocation()
  const questionId = location.state?.questionId
  const fromPage = location.state?.fromPage || 1
  const level = location.state?.level || 1

  const { data } = useQuestionsDetail({ QUESTION_ID: questionId })

  return (
    <AdminLayout>
      <AdminContentLayout>
        <QuizContent
          data={data?.data?.[0]}
          questionId={questionId}
          fromPage={fromPage}
          level={level}
        />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default QuizEdit
